<app-default-progress-bar *ngIf="contactList == null || showProgressBar"></app-default-progress-bar>

<table
	[dataSource]="contactsDataTable"
	[ngClass]="{ 'mat-elevation-z8': !isCarrierProfile }"
	[ngStyle]="{ border: isCarrierProfile ? '1px solid ' + tableBorderColor : 'none' }"
	class=""
	mat-table
	matSort
	style="width: 100%"
>
	<ng-container matColumnDef="firstName">
		<th *matHeaderCellDef mat-header-cell mat-sort-header class="sort_header_no_border">
			<span class="fs-13 color-black">First Name</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			{{ element.firstName?.replace('null', '') }}
		</td>
	</ng-container>

	<ng-container matColumnDef="lastName">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black">Last Name</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			{{ element.lastName?.replace('null', '') }}
		</td>
	</ng-container>

	<ng-container matColumnDef="email">
		<th *matHeaderCellDef mat-header-cell>
			<span class="fs-13 color-black">Email</span>
			<span
				*ngIf="IS_NOT_NULL_OR_UNDEFINED(contactList) && showContactSearchIcon"
				class="cursor-pointer"
			>
				<mat-icon (click)="showContactSearchDialog()" class="contact-search-icon">search</mat-icon>
			</span>
		</th>
		<td
			[matTooltip]="
				element.prioritizedContact ? 'Emails will go to this contact for this carrier.' : ''
			"
			*matCellDef="let element"
			mat-cell
		>
			<a href="mailto:{{ element.emailAddress }}" (click)="onContactChannelClick()">{{
				element.emailAddress || '' | lowercase
			}}</a>
		</td>
	</ng-container>

	<ng-container matColumnDef="emailValidation">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black">Validated</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<span *ngIf="element.vettingAuthorized" class="font-size-16">
				<mat-icon
					[matTooltip]="EMAIL_VALIDATED_TOOLTIP(element)"
					class="contact-verification-good"
					matSuffix
					>check_circle</mat-icon
				>
			</span>
		</td>
	</ng-container>

	<ng-container matColumnDef="phoneNumber">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black">Phone Number</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<span *ngIf="!utilService.isNullOrUndefined(element.phone) && element.phone.length > 0">
				<span *ngFor="let phone of element.phone.split(',')">
					<a href="tel:{{ phone }}" (click)="onContactChannelClick()">
						{{ phone | mask: '(000) 000-0000' }}
						{{
							phone.split(';')[1] != undefined && phone.split(';')[1] != null
								? ' ext. ' + phone.split(';')[1]
								: ''
						}}
						<br />
					</a>
				</span>
			</span>
		</td>
	</ng-container>

	<ng-container *ngIf="isCarrierProfile" matColumnDef="mobileNumber">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black">Mobile Number</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<a
				href="tel:{{ element.mobileNumber }}"
				*ngIf="element?.mobileNumber?.length"
				(click)="onContactChannelClick()"
			>
				{{ element.mobileNumber | mask: '(000) 000-0000' }}
			</a>
		</td>
	</ng-container>

	<ng-container *ngIf="!isCarrierProfile || editPrimaryContact" matColumnDef="primaryContact">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black">Primary Contact </span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<mat-slide-toggle
				(change)="primaryContactToggled($event, element)"
				[checked]="element.primaryContact"
				color="primary"
			>
			</mat-slide-toggle>
		</td>
	</ng-container>

	<ng-container *ngIf="!isCarrierProfile" matColumnDef="emailFailedReason">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black">Email Failed</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<mat-icon
				*ngIf="element.emailFailedReason"
				class="contact-verification-bad"
				[matTooltip]="
					element.emailFailedAt
						? 'Email delivery failed at : ' +
							(element.emailFailedAt | date: 'MM/dd/yyyy') +
							' for reason: ' +
							element.emailFailedReason
						: 'Email delivery failed for reason: ' + element.emailFailedReason
				"
				matSuffix
				>error</mat-icon
			>
		</td>
	</ng-container>

	<ng-container *ngIf="!isCarrierProfile" matColumnDef="emailLastValidated">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black">Last Validated</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			{{ element.emailLastValidated | date: 'MM/dd/yyyy' }}
		</td>
	</ng-container>

	<ng-container *ngIf="!isCarrierProfile" matColumnDef="actions">
		<th *matHeaderCellDef mat-header-cell>
			<span class="fs-13 color-black">Actions</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<app-carrier-contact-actions
				(updatedContacts)="contactList = $event; buildDatatableView()"
				[carrierId]="carrierId"
				[carrier]="carrier"
				[contactList]="contactList"
				[contact]="element"
				[oldCarrierId]="oldCarrierId"
			></app-carrier-contact-actions>
		</td>
	</ng-container>

	<ng-container *ngIf="incorrectContactInfoEnabled" matColumnDef="contactFeedback">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black"></span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<mat-icon
				(click)="contactFeedback(element)"
				class="cursor-pointer primary-text"
				fxLayoutAlign="center center"
			>
				edit
			</mat-icon>
		</td>
	</ng-container>

	<ng-container *ngIf="isEditContact" matColumnDef="editColumn">
		<th *matHeaderCellDef mat-header-cell>
			<mat-icon
				*ngIf="showAddContactIcon"
				(click)="openContactDialog(null)"
				class="cursor-pointer primary-text"
				fxLayoutAlign="center center"
				matTooltip="Add Contact"
			>
				person_add_alt_1
			</mat-icon>
		</th>
		<td *matCellDef="let element" mat-cell>
			<mat-icon
				(click)="openContactDialog(element)"
				class="cursor-pointer primary-text"
				fxLayoutAlign="center center"
				matTooltip="Edit Contact"
			>
				edit
			</mat-icon>
		</td>
	</ng-container>

	<ng-container *ngIf="!hideSetEmailRecipientColumn" matColumnDef="markAsAccountContact">
		<th *matHeaderCellDef mat-header-cell></th>
		<td *matCellDef="let element" mat-cell>
			<!-- CN-8616: "Set Email Recipient" — a plain envelope read as "send email", which
			     this is not. Compose envelope + a small swap badge so it reads as "route future
			     emails to this contact" instead. -->
			<span
				(click)="!element.prioritizedContact ? setAccountCarrierContact(element) : null"
				[class]="
					element.prioritizedContact
						? 'set-email-recipient disabled-icon'
						: 'set-email-recipient cursor-pointer primary-text'
				"
				fxLayoutAlign="center center"
				matTooltip="Set as email recipient"
			>
				<mat-icon>email</mat-icon>
				<mat-icon class="set-email-recipient__badge">swap_horiz</mat-icon>
			</span>
		</td>
	</ng-container>

	<ng-container matColumnDef="reportColumn">
		<th *matHeaderCellDef mat-header-cell></th>
		<td *matCellDef="let element" mat-cell>
			<mat-icon
				(click)="reportDataAction('contact')"
				class="cursor-pointer primary-text"
				fxLayoutAlign="center center"
				matTooltip="Report Contact"
			>
				report
			</mat-icon>
		</td>
	</ng-container>

	<ng-container *ngIf="mapContactToProjectColumnEnabled" matColumnDef="offerContactColumn">
		<th *matHeaderCellDef mat-header-cell class="offer_contact_container">
			<span class="fs-13 color-black">Offer (TO)</span>
		</th>
		<td
			*matCellDef="let element"
			mat-cell
			class="offer_contact_container"
			(click)="$event.stopPropagation()"
		>
			<div fxLayout="row" fxLayoutAlign="start center">
				<button
					type="button"
					mat-icon-button
					class="primary-text"
					(click)="setOfferContact(element)"
					[attr.aria-pressed]="element.isOfferContact"
					[attr.aria-label]="
						element.isOfferContact ? 'Offer (TO) contact' : 'Set as offer (TO) contact'
					"
					[matTooltip]="
						element.isOfferContact
							? 'Offer (TO) contact — load offers go here'
							: 'Set as offer (TO) contact'
					"
				>
					<mat-icon>{{
						element.isOfferContact ? 'radio_button_checked' : 'radio_button_unchecked'
					}}</mat-icon>
				</button>
				<button
					*ngIf="element.isOfferContact"
					type="button"
					mat-icon-button
					class="danger-text"
					(click)="removeOfferContact(element)"
					aria-label="Remove offer contact (revert to carrier default)"
					matTooltip="Remove offer contact (revert to carrier default)"
				>
					<mat-icon>remove_circle_outline</mat-icon>
				</button>
			</div>
		</td>
	</ng-container>

	<ng-container *ngIf="mapContactToProjectColumnEnabled" matColumnDef="ccContactColumn">
		<th *matHeaderCellDef mat-header-cell class="cc_contact_container">
			<span class="fs-13 color-black">CC</span>
		</th>
		<td
			*matCellDef="let element"
			mat-cell
			class="cc_contact_container"
			(click)="$event.stopPropagation()"
		>
			<mat-slide-toggle
				*ngIf="!element.isOfferContact"
				(change)="toggleCcContact($event, element)"
				[checked]="element.contactMappedToProject"
				color="primary"
				aria-label="CC this contact on invite and notification emails"
				matTooltip="CC this contact on invite & notification emails"
			>
			</mat-slide-toggle>
		</td>
	</ng-container>

	<ng-container *ngIf="showBidContactsInfo" matColumnDef="bidContactInfo">
		<th *matHeaderCellDef mat-header-cell>
			<span class="fs-13 color-black">Offer</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<span *ngIf="element.bidToContact" class="bid-contact-chip bid-contact-chip--to">TO</span>
			<span *ngIf="element.ccContact" class="bid-contact-chip bid-contact-chip--cc">CC</span>
		</td>
	</ng-container>

	<tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
	<tr
		*matRowDef="let row; columns: displayedColumns"
		[ngClass]="{
			'font-weight-bold':
				(isCarrierProfile &&
					!isContactMappedToProject &&
					((!hasPrioritizedContact && row.primaryContact) || row.prioritizedContact)) ||
				(isContactMappedToProject && row.contactMappedToProject),
			selected_contact:
				rowSelectionEnabled && selectedContactRow && selectedContactRow?.id === row.id,
			row_hover: rowSelectionEnabled,
			'prioritized-contact-row': row.prioritizedContact
		}"
		mat-row
		(click)="rowSelectionEnabled ? onContactRowSelection(row) : null"
	></tr>
</table>

<mat-paginator
	*ngIf="totalNumberOfContacts > PAGE_SIZE"
	[length]="totalNumberOfContacts"
	[ngClass]="{ 'mat-elevation-z8': !isCarrierProfile }"
	[ngStyle]="{
		borderLeft: isCarrierProfile ? '1px solid ' + tableBorderColor : 'none',
		borderBottom: isCarrierProfile ? '1px solid ' + tableBorderColor : 'none',
		borderRight: isCarrierProfile ? '1px solid ' + tableBorderColor : 'none'
	}"
	[pageSizeOptions]="[PAGE_SIZE]"
	showFirstLastButtons
>
</mat-paginator>
